import { MbscEventcalendarView } from '@mobiscroll/react'
import { RotaInstanceStatus } from 'screens/Rostering/types'

export const AVATAR_DEFAULT =
  'https://lmc-data-production.s3.eu-west-2.amazonaws.com/public/profile_avatar_blank_X5.png'

export const CalendarOptions: {
  daily: MbscEventcalendarView['timeline']
  dailyZoomed: MbscEventcalendarView['timeline']
  weekly: MbscEventcalendarView['timeline']
} = {
  daily: {
    type: 'day',
    resolutionHorizontal: 'hour',
    timeCellStep: 60,
    timeLabelStep: 60,
    // eventHeight: 'variable',
    maxEventStack: 3,
  },
  dailyZoomed: {
    type: 'day',
    resolutionHorizontal: 'hour',
    timeCellStep: 30,
    timeLabelStep: 60,
    // eventHeight: 'variable',
    maxEventStack: 3,
  },
  weekly: {
    type: 'week',
    startDay: 1,
    endDay: 0,
    eventList: true,
    weekNumbers: false,
    // eventHeight: 'variable',
    maxEventStack: 3,
  },
}

export const getCalendarOptionsWithEventStack = (
  showAllEvents: boolean = false,
  featureFlagEnabled: boolean = true
): typeof CalendarOptions => ({
  daily: {
    ...CalendarOptions.daily,
    maxEventStack: featureFlagEnabled && showAllEvents ? undefined : 3,
  },
  dailyZoomed: {
    ...CalendarOptions.dailyZoomed,
    maxEventStack: featureFlagEnabled && showAllEvents ? undefined : 3,
  },
  weekly: {
    ...CalendarOptions.weekly,
    maxEventStack: featureFlagEnabled && showAllEvents ? undefined : 3,
  },
})

export const statusToColorMap: Record<RotaInstanceStatus, string> = {
  [RotaInstanceStatus.DRAFT]: '#999999',
  [RotaInstanceStatus.PENDING]: '#9ACEFF',
  [RotaInstanceStatus.DUE]: '#1890FF',
  [RotaInstanceStatus.IN_PROGRESS]: '#9966FB',
  [RotaInstanceStatus.OVERDUE]: '#E01E4E',
  [RotaInstanceStatus.DONE]: '#37A598',
  [RotaInstanceStatus.CANCELLED]: '#595959',
}

export const themeOptions = {
  theme: 'ios',
  themeVariant: 'light',
}
